import { IEquipment } from '@/pages/Equipment/equipment.types'
import BadgeStatus from '@/shared/Badges/BadgeStatus'
import css from './favouriteEquipmentLinkItem.module.css'
import cn from '@/utils/cn'
import LinkIcon from '@/assets/icons/externalLink.svg?react'
import equipmentUtils from '@/pages/Equipment/equipment.utils'

interface IProps {
  equipment: IEquipment
  onClick: (equipmentId: IEquipment['id']) => void
}

const FavouriteEquipmentLinkItem = (props: IProps) => {
  const getBadgeStatusType = (e: IEquipment) => {
    if (e.state === 'DISCONNECTED') return 'dark' // Если лифт отключен, его статутс не актуален
    switch (true) {
      case e.statusFlag === 'IN_MAINTENANCE':
        return 'blue'
      case e.statusFlag === 'WARNING':
        return 'warning'
      case e.statusFlag === 'ERROR':
      case e.statusFlag === 'FATAL_FAULT':
      case e.state === 'ERROR':
        return 'error'
      case e.state === 'PENDING':
        return 'processing'
      case e.state === 'STOPPED':
        return 'dark'
      case e.state === 'RUNNING':
        return 'success'
    }
  }

  if (!props.equipment) return null

  return (
    <div
      key={props.equipment.id}
      onClick={() => props.onClick(props.equipment.id)}
      className={cn('inline-flex-gap gap12 center', css.wrapper)}
    >
      <BadgeStatus type={getBadgeStatusType(props.equipment)} />
      <p className="text-nm line-clamp">
        {equipmentUtils.getEquipmentAddress(props.equipment.location, {
          includeLocationDescription: true,
          includeCountry: false,
        })}
      </p>
      <LinkIcon style={{ marginLeft: 'auto' }} />
    </div>
  )
}

export default FavouriteEquipmentLinkItem
